// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__20bsr","subtitle":"card_subtitle__1yjxG","name":"card_name__1xBDT"};